import * as React from 'react';
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {DisableableProps} from "../../common/props/DisableableProps";
import {EditableProps} from "../../common/props/EditableProps";
import {FocusableProps} from "../../common/props/FocusableProps";
import {TrimableProps} from "../../common/props/TrimableProps";
import {none, Option} from "ts-option";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import InputWithIcon from "../../../hiberUiKit/src/atoms/Input/InputWithIcon";

type Props = EditableProps & FormGroupProps<string> & PlaceholderProps & DisableableProps & FocusableProps & TrimableProps

export default class ClearableInputFormGroup extends React.Component<Props, {}> {

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<InputWithIcon type={"text"} value={this.props.field.value.getOrElse("")}
							   placeholder={this.props.placeholder}
							   disabled={this.props.disabled}
							   readonly={this.props.readonly}
							   focus={this.props.focus}
							   clearable={true}
							   onClearClick={() => this.onChange(none)}
							   onFocus={this.props.onFocus}/>
			</FormGroup>
		);
	}

	onChange(value: Option<string>) {
		this.props.onChange(this.props.field.updateValue(value.map(v => this.props.trimRight ? v.trimRight() : v)))
	}
}
